/**
 * Copyright (c) 2021, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 */

'use strict';

/**
 * oj-vb-fragment
 * @since  2201.0.0
 *
 * A wrapper of the oj-module composite component used to extend the capabilities to support loading a fragment
 * in a VB app.
 *
 * <code>
 * &lt;oj-vb-fragment name='[[ nameOfFragment]]' id='myId'
 *   animation='[[moduleAnimation]]'>
 * &lt;/oj-vb-fragment>
 * </code>
 *
 */
define('vb/components/oj-vb-fragment/loader',[
  'ojs/ojcomposite',
  'text!./component.json',
  './fragmentViewModel',
  'ojs/ojmodule-element',
  'css!./styles.css',
], (Composite, metadataJson, viewModel) => {
  const metadata = JSON.parse(metadataJson);
  const view = '<oj-module config="[[ getModuleConfig() ]]" animation="[[ $props.animation]]"></oj-module>';

  Composite.register('oj-vb-fragment', {
    view,
    viewModel,
    metadata,
  });
});

